module.exports = __webpack_public_path__ + "media/components/country-flag/static/bo-6fef385ed9f8ec34224102440f373362.svg";